import * as React from 'react'
import { useAccount, usePublicClient } from 'wagmi'
import { NFT_LUMIR_13W } from '../address'
import { ERC_BALANCE_ABI } from '../abi'
import { API_URL } from 'env'
import { toast } from 'react-toastify'

export function useBalanceOf(ownerAddress?: string): string {
    const { address: connectedAddress } = useAccount()
    const owner = ownerAddress ?? connectedAddress

    const publicClient = usePublicClient()
    const [balance, setBalance] = React.useState('Loading...')

    React.useEffect(() => {
        if (!owner) {
            setBalance('—')
            return
        }

        const fetchData = async () => {
            try {
                // @ts-ignore
                const res = await publicClient.readContract({
                    address: NFT_LUMIR_13W as `0x${string}`,
                    abi: ERC_BALANCE_ABI,
                    functionName: 'balanceOf',
                    args: [owner as `0x${string}`],
                })
                setBalance(String(res))
            } catch (e) {
                setBalance('Error')
            }
        }

        fetchData()
    }, [owner, publicClient])

    return balance
}

export async function checkUserHaveNFT(publicClient: any, ownerAddress?: string): Promise<boolean> {

    if (!publicClient || !ownerAddress) {
        return false
    }

    // @ts-ignore
    const res = await publicClient.readContract({
        address: NFT_LUMIR_13W as `0x${string}`,
        abi: ERC_BALANCE_ABI,
        functionName: 'balanceOf',
        args: [ownerAddress as `0x${string}`],
    })
    const balance = String(res)
    return (
        balance !== '0' &&
        balance !== 'Loading...' &&
        balance !== 'Error' &&
        balance !== '—'
    )
}


export function useCheckIsHaveNFT(ownerAddress?: string): boolean {
    const balance = useBalanceOf(ownerAddress)

    return (
        balance !== '0' &&
        balance !== 'Loading...' &&
        balance !== 'Error' &&
        balance !== '—'
    )
}

export async function updateUidAndAddress(uid: string, address: `0x${string}`) {
    try {
        const response = await fetch(API_URL + `/api/v1/be/13w-challenges/update-wallet`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                user_id: uid,
                wallet_address: address,
            }),
        })
        if (response.status === 200) {
            toast.success('Wallet address linked successfully!')
            return true
        }
        else if (response.status === 409) {
            toast.error('This wallet address is already linked to another account.')
            return false
        }
        else {
            toast.error('Failed to link wallet address. Please try again.')
            return false
        }
    } catch (error) {
        console.error('Error updating wallet address:', error)
        return false
    }
}


export async function checkAndUpdateAddressToBackend(publicClient: any, uid: string, address: `0x${string}`): Promise<boolean> {
    try {
        const hasNft = await checkUserHaveNFT(publicClient, address)
        if (hasNft) {
            const result = await updateUidAndAddress(uid, address)
            return result
        } else {
            return false
        }
    } catch (error) {
        console.error('Error checking and updating wallet address:', error)
        return false
    }
}